import React from "react"
import { useCore } from "@hooks/useCore"
import { Location } from "@root/types/global"

export interface ProductSectionsProps {
  product?: GatsbyTypes.SanityProduct
  location: Location
}

const ProductSections = ({ product, location }: ProductSectionsProps) => {
  const {
    helpers: { ErrorBoundary },
  } = useCore()

  return (
    <ErrorBoundary>
      {product?.content?.map((section: any) => {
        const name = section._type?.replace("section", "")
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const SectionComponent = require(`../Sections/${name}/${name}`).default
        return <SectionComponent key={section._key?.toString()} name={name} location={location} section={section} sanityProduct={product} video={section?.video} />
      })}
    </ErrorBoundary>
  )
}

export default React.memo(ProductSections)
